import { apiClient } from "helpers/api_helper";
import { API } from "../constant/api.const";

export const getPoProductList = async (data: object) => {
    try {
        const response = await apiClient.get(API.GET_PO_ORDERS, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getPoProductListById = async (data: object) => {
    try {
        const response = await apiClient.get(API.GET_PO_ORDER_BY_ID, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getPoProductDocByinvoiceNo = async (invoiceNo: object) => {
    try {
        const response = await apiClient.get(API.VIEW_DOC_PO_ORDER, invoiceNo);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};